var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgReload = function SvgReload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.973 8C1.973 4.975 4.33 1.973 8 1.973c2.963 0 4.428 2.193 5.052 3.36H11.2a.533.533 0 0 0 0 1.067h3.2a.533.533 0 0 0 .533-.534v-3.2a.533.533 0 0 0-1.067 0V4.6C13.115 3.276 11.376.906 8 .906 3.666.906.906 4.464.906 8c0 3.535 2.76 7.093 7.094 7.093 2.073 0 3.8-.82 5.028-2.071a7.224 7.224 0 0 0 1.523-2.312.533.533 0 0 0-.986-.406 6.156 6.156 0 0 1-1.297 1.97C11.23 13.33 9.776 14.026 8 14.026c-3.67 0-6.027-3.002-6.027-6.026Z",
    fill: "#A0A0A0"
  })));
};

export default SvgReload;